import { Controller } from "stimulus"

export default class extends Controller {
  current_title = '';
  
  edit_description(event) {
    var id = $(event.target).parent().data('issue-id');
    $("#issue-desc-" + id + " #issue-description").removeClass("d-none");
    $("#issue-desc-" + id + " .description").hide();
    $(event.target).parent().remove();
  }

  edit_title(event) {
    var title_div = $(event.target).parent().parent();
    var title = $(event.target).parent().data('title');
    console.log(title, title_div)
    var anchor = title_div.find('a')[0];
    title_div.find('a').hide();
    this.current_title = title;
    var html = "<input type=\"text\" class=\"form-control\" id='edit-issue-title' value=\""+ title + "\" data-action=\"focusout->inline-edit-issues#update_title keydown->inline-edit-issues#update_title\" autofocus>"
    $(html).insertAfter(anchor);
    title_div.find('span').remove();
  }

  update_title(event) {
    var updated_title = $(event.target).val();
    var view_as = $("input[name=view_as]:checked").val();
    if (updated_title !== "" && (event.type === 'focusout' || event.keyCode === 13)) {
      var title_div = $(event.target).parent();
      var anchor = title_div.find('a');
      var id = anchor.attr('id').replace("issue_", "");
      var short_text = $.trim(updated_title).substring(0, 115);
      short_text += (updated_title.length > 115) ? "..." : '';
      anchor.show();
      $(event.target).val('');
      title_div.find('input').remove();
      var html = '<span class="edit-title" data-title="'
      if( updated_title == this.current_title ) {
        html += this.current_title + '" data-action="click->inline-edit-issues#edit_title"><i class="fa fa-pen" aria-hidden="true"></i></span>';
        $(html).insertAfter(anchor);
      } else {
        var data = new FormData();
        data.append("issue[title]", updated_title);
        Rails.ajax({
          url: "/issues/" + id,
          type: 'PUT',
          data: data,
          dataType: 'json',
          success: function(response) {
            if(response.status) {
              html += this.current_title;
            } else {
              html += updated_title;
              (view_as == 'card') ? title_div.find('a').html(short_text) : title_div.find('a').html(updated_title);
            }
            html += '" data-action="click->inline-edit-issues#edit_title"><i class="fa fa-pen" aria-hidden="true"></i></span>';
            $(html).insertAfter(anchor);
          }
        });
      }
    }
  }
}
